import moment from 'moment';
import { joinArrayItems } from '../../../core/utils/format-array';
import {
  EMPTY_LABEL,
  countries,
  workStatus,
  states,
  languages,
  smartphoneOs,
  computerOs,
  tabletOs,
} from './constants';

const renderValue = (value) => {
  if (!value || value.length === 0) {
    return EMPTY_LABEL;
  }

  return value;
};

const formatDate = (date) => {
  if (date === EMPTY_LABEL) return date;

  return moment(date).format('MM/DD/YYYY');
};

const formatJobCategory = (jobCategoryArr) => {
  if (jobCategoryArr === EMPTY_LABEL) return jobCategoryArr;

  const jobCategories = jobCategoryArr.map((jobCategory) => jobCategory.name);

  return joinArrayItems(jobCategories);
};

const formatCountry = (countryKey) => {
  if (countryKey === EMPTY_LABEL) return countryKey;

  const countryFormat = countries.find((country) => country.key === countryKey);
  return countryFormat?.text;
};

const formatState = (stateKey) => {
  if (stateKey === EMPTY_LABEL) return stateKey;

  const stateObj = states.find((state) => state.key === stateKey);

  return stateObj?.text || EMPTY_LABEL;
};

const formatLanguage = (languageArr) => {
  if (languageArr === EMPTY_LABEL) return languageArr;

  const languageFormattedArr = [];

  languages.forEach((language) => {
    if (languageArr.includes(language.key)) {
      languageFormattedArr.push(language.text);
    }
  });

  return joinArrayItems(languageFormattedArr);
};

const formatWorkStatus = (workStatusKey) => {
  if (workStatusKey === EMPTY_LABEL) return workStatusKey;

  const workStatusFormattedArr = [];

  workStatus.forEach((workStatusValue) => {
    if (workStatusKey.includes(workStatusValue.key)) {
      workStatusFormattedArr.push(workStatusValue.text);
    }
  });

  return joinArrayItems(workStatusFormattedArr);
};

const formatSmartphone = (smartphoneKey) => {
  if (smartphoneKey === EMPTY_LABEL) return smartphoneKey;

  const smartphoneFormattedArr = [];

  smartphoneOs.forEach((smartphone) => {
    if (smartphoneKey.includes(smartphone.key)) {
      smartphoneFormattedArr.push(smartphone.text);
    }
  });

  return joinArrayItems(smartphoneFormattedArr);
};

const formatComputer = (computerKey) => {
  if (computerKey === EMPTY_LABEL) return computerKey;

  const computerFormattedArr = [];

  computerOs.forEach((computer) => {
    if (computerKey.includes(computer.key)) {
      computerFormattedArr.push(computer.text);
    }
  });

  return joinArrayItems(computerFormattedArr);
};

const formatTablet = (tabletKey) => {
  if (tabletKey === EMPTY_LABEL) return tabletKey;

  const tabletFormattedArr = [];

  tabletOs.forEach((tablet) => {
    if (tabletKey.includes(tablet.key)) {
      tabletFormattedArr.push(tablet.text);
    }
  });

  return joinArrayItems(tabletFormattedArr);
};

export {
  renderValue,
  formatLanguage,
  formatState,
  formatDate,
  formatCountry,
  formatJobCategory,
  formatSmartphone,
  formatComputer,
  formatWorkStatus,
  formatTablet,
};
